import { Component, Input } from '@angular/core';
import { MainInfoData } from '../../invoice.model';

@Component({
	selector: 'invoice-main-info',
	template: require('./invoice-main-info.html'),
	styles: [require('./invoice-main-info.scss')]
})
export class InvoiceMainInfoComponent {
	@Input() mainInfoData: MainInfoData;
	@Input() datePickerHolder: string;

	constructor() {}
}



// WEBPACK FOOTER //
// ./node_modules/angular2-template-loader!./node_modules/string-replace-webpack-plugin/loader.js?id=kkml25e9zf!./web/modern/components/invoices/invoice-update/invoice-main-info/invoice-main-info.ts